import { render } from "./ChiamateCameriere.vue?vue&type=template&id=136bca49&scoped=true"
import script from "./ChiamateCameriere.vue?vue&type=script&lang=js"
export * from "./ChiamateCameriere.vue?vue&type=script&lang=js"

import "./ChiamateCameriere.vue?vue&type=style&index=0&id=136bca49&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136bca49"]])

export default __exports__